export const DashboardSVG = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.68421 7.71429H4V6H5.68421V7.71429ZM20 7.71429H7.36842V6H20V7.71429ZM5.68421 12.8571H4V11.1429H5.68421V12.8571ZM20 12.8571H7.36842V11.1429H20V12.8571ZM5.68421 18H4V16.2857H5.68421V18ZM20 18H7.36842V16.2857H20V18Z"
      fill="currentColor"
    />
  </svg>
);

export const ContentSVG = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 4.63636C5 3.73262 5.69645 3 6.55556 3H14.3333C14.5396 3 14.7374 3.0862 14.8833 3.23964L18.7722 7.33055C18.9181 7.48399 19 7.6921 19 7.90909V19.3636C19 20.2674 18.3036 21 17.4444 21H6.55556C5.69645 21 5 20.2674 5 19.3636V4.63636ZM14.0112 4.63636H6.55556V19.3636H17.4444V8.24799L14.0112 4.63636Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 10C8 9.44772 8.35817 9 8.8 9H15.2C15.6418 9 16 9.44772 16 10C16 10.5523 15.6418 11 15.2 11H8.8C8.35817 11 8 10.5523 8 10Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 14C8 13.4477 8.35817 13 8.8 13H15.2C15.6418 13 16 13.4477 16 14C16 14.5523 15.6418 15 15.2 15H8.8C8.35817 15 8 14.5523 8 14Z"
      fill="currentColor"
    />
  </svg>
);

export const SystemSVG = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.73684 5C5.3299 5 5 5.3299 5 5.73684V10.5263C5 10.9333 5.3299 11.2632 5.73684 11.2632H10.5263C10.9333 11.2632 11.2632 10.9333 11.2632 10.5263V5.73684C11.2632 5.3299 10.9333 5 10.5263 5H5.73684ZM6.47368 9.78947V6.47368H9.78947V9.78947H6.47368ZM13.4737 5C13.0667 5 12.7368 5.3299 12.7368 5.73684V10.5263C12.7368 10.9333 13.0667 11.2632 13.4737 11.2632H18.2632C18.6701 11.2632 19 10.9333 19 10.5263V5.73684C19 5.3299 18.6701 5 18.2632 5H13.4737ZM14.2105 9.78947V6.47368H17.5263V9.78947H14.2105ZM5 13.4737C5 13.0667 5.3299 12.7368 5.73684 12.7368H10.5263C10.9333 12.7368 11.2632 13.0667 11.2632 13.4737V18.2632C11.2632 18.6701 10.9333 19 10.5263 19H5.73684C5.3299 19 5 18.6701 5 18.2632V13.4737ZM6.47368 14.2105V17.5263H9.78947V14.2105H6.47368ZM13.4737 12.7368C13.0667 12.7368 12.7368 13.0667 12.7368 13.4737V18.2632C12.7368 18.6701 13.0667 19 13.4737 19H18.2632C18.6701 19 19 18.6701 19 18.2632V13.4737C19 13.0667 18.6701 12.7368 18.2632 12.7368H13.4737ZM14.2105 17.5263V14.2105H17.5263V17.5263H14.2105Z"
      fill="currentColor"
    />
  </svg>
);

export const ViewSVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#572DF3" />
    <path
      d="M32.066 40.5979C39.9207 40.5979 46.2882 32.0646 46.2882 32.0646C46.2882 32.0646 39.9207 23.5312 32.066 23.5312C24.2113 23.5312 17.8438 32.0646 17.8438 32.0646C17.8438 32.0646 24.2113 40.5979 32.066 40.5979Z"
      stroke="white"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M32.0634 35.6189C34.027 35.6189 35.6189 34.027 35.6189 32.0634C35.6189 30.0997 34.027 28.5078 32.0634 28.5078C30.0997 28.5078 28.5078 30.0997 28.5078 32.0634C28.5078 34.027 30.0997 35.6189 32.0634 35.6189Z"
      stroke="white"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);

export const PeopleSVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#F2A63B" />
    <path
      d="M32.0012 29.6587C34.7504 29.6587 36.979 27.4301 36.979 24.6809C36.979 21.9318 34.7504 19.7031 32.0012 19.7031C29.2521 19.7031 27.0234 21.9318 27.0234 24.6809C27.0234 27.4301 29.2521 29.6587 32.0012 29.6587Z"
      stroke="#EEF0F4"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.2031 44.4538V45.3071H44.8031V44.4538C44.8031 41.2677 44.8031 39.6747 44.1831 38.4578C43.6377 37.3873 42.7674 36.517 41.6969 35.9716C40.48 35.3516 38.887 35.3516 35.7009 35.3516H28.3053C25.1193 35.3516 23.5263 35.3516 22.3093 35.9716C21.2389 36.517 20.3686 37.3873 19.8232 38.4578C19.2031 39.6747 19.2031 41.2677 19.2031 44.4538Z"
      stroke="#EEF0F4"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UserSVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#EA3AB0" />
    <path
      d="M32.5026 46.2257C38.3584 46.2257 43.1691 41.5851 43.1691 35.6288C43.1691 34.1665 43.0948 32.599 42.2843 30.1628C41.4738 27.7267 41.3105 27.4123 40.4535 25.9078C40.0873 28.978 38.1282 30.2576 37.6305 30.64C37.6305 30.2421 36.4454 25.8423 34.6485 23.2098C32.8845 20.6257 30.4855 18.9303 29.0788 17.7812C29.0788 19.9642 28.4648 23.2098 27.5856 24.8635C26.7063 26.5172 26.5411 26.5774 25.4428 27.8081C24.3446 29.0387 23.8405 29.4188 22.9221 30.912C22.0037 32.4052 21.8359 34.3941 21.8359 35.8563C21.8359 41.8127 26.6468 46.2257 32.5026 46.2257Z"
      stroke="white"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);
export const FeedbackScoreSVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#572DF3" />
    <path
      d="M31.999 18.25L27.4142 27.6082L17 29.1183L24.5442 36.4938L22.7408 46.75L31.999 41.8144L41.2591 46.75L39.4689 36.4938L47 29.1183L36.6435 27.6082L31.999 18.25Z"
      stroke="white"
      stroke-width="2"
    />
  </svg>
);
export const FeedbackNumberSVG = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="64" height="64" fill="#FF7335" />
    <path
      d="M17 45.5H47"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M24.5 35H20V45.5H24.5V35Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
    <path
      d="M34.25 27.5H29.75V45.5H34.25V27.5Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M44 18.5H39.5V45.5H44V18.5Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
export const FeedbackExportSVG = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.00391 9.88736V1.75" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M10.5 6.41602L7 9.91602L3.5 6.41602"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M10.5 12.25H3.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
export const DTShtTop123SVG = () => (
  <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.113281" width="24" height="24" rx="2" fill="white" />
    <g clip-path="url(#clip0_4173_40349)">
      <path
        d="M12 15.25C14.4853 15.25 16.5 13.176 16.5 10.6177V5.5H7.5V10.6177C7.5 13.176 9.51473 15.25 12 15.25Z"
        stroke="currentColor"
        stroke-width="1.125"
      />
      <path
        d="M12 14C13.6568 14 15 12.511 15 10.6742V7H9V10.6742C9 12.511 10.3432 14 12 14Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.5 11.875V8.125H4.5C4.5 10.625 6 11.875 7.5 11.875Z"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="square"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5 11.875V8.125H19.5C19.5 10.625 18 11.875 16.5 11.875Z"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="square"
      />
      <path d="M12 16V17.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="square" />
      <path
        d="M8.625 19.75L10.0088 17.5H13.8909L15.375 19.75H8.625Z"
        stroke="currentColor"
        stroke-width="1.125"
      />
    </g>
    <defs>
      <clipPath id="clip0_4173_40349">
        <rect width="18" height="16" fill="white" transform="translate(3 4)" />
      </clipPath>
    </defs>
  </svg>
);
